module.exports = __webpack_public_path__ + "static/media/incident_category-natural_disaster.9323d510.svg";